import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cmps-sc-toggle-switch',
    templateUrl: './sc-toggle-switch.html',
    styles: [
        `
            .switch {
                position: relative;
                display: inline-block;
                width: 50px;
                height: 28px;
                margin: 0;
            }

            .switch input {
                display: none;
                background-color: #ccc;
            }

            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #ccc;
                -webkit-transition: 0.4s;
                transition: 0.4s;
            }

            .slider[cmps-sc-is-selected='true'] {
                background-color: #1e60d2;
            }

            .slider[cmps-sc-can-be-toggled='false'] {
                cursor: not-allowed;
            }

            .slider:before {
                position: absolute;
                content: '';
                height: 24px;
                width: 24px;
                left: 3px;
                right: 0px;
                bottom: 2px;
                background-color: #fff;
                -webkit-transition: 0.4s;
                transition: 0.4s;
            }

            input:checked + .slider:before {
                -webkit-transform: translateX(20px);
                -ms-transform: translateX(20px);
                transform: translateX(20px);
            }

            /* Rounded sliders */
            .slider.round {
                border-radius: 20px;
            }

            .slider.round:before {
                border-radius: 50%;
            }
        `,
    ],
})
export class ScToggleSwitchComponent {
    @Input() isSelected: boolean;
    @Input() text: string;
    @Input() canBeToggled: boolean;

    @Output() toggleSelection: EventEmitter<boolean>;

    constructor() {
        this.isSelected = false;
        this.text = '';
        this.canBeToggled = true;

        this.toggleSelection = new EventEmitter();
    }

    /** @private */ _onToggleIsSelected(isSelected: boolean): void {
        if (this.canBeToggled) {
            this.toggleSelection.emit(isSelected);
        }
    }
}
